export const formatTime = (timeInSeconds) => {
  const isNegative = timeInSeconds < 0;
  const absTime = Math.abs(timeInSeconds);

  const minutes = Math.floor(absTime / 60);
  const seconds = Math.floor(absTime % 60);
  const milliseconds = Math.floor((absTime % 1) * 100);

  return `${isNegative ? '-' : ''}${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${milliseconds
    .toString()
    .padStart(2, '0')}`;
};


//constants
export const STORAGE_KEYS = {
  MULTIPLIER: '@gpx_scanState_multiplier',
  ACCUMULATOR: '@gpx_scanState_accumulatorProgress',
  SCORE: '@gpx_scanState_score',
  DATE: '@gpx_scanState_lastSavedDate',
};

export const EXPECTED_SCAN_TIME = 4;
